<style scoped>
    .company-name{
        display: inline-block;
        vertical-align: middle;
        font-size: 18px;
        font-weight: bold;
    }
    table{
        border-collapse:collapse;
        border: 1px solid #dddee1;
        width: 100%;
        text-align: center;
    }
    table tr{
        border-bottom: 1px solid #dddee1;
    }
    table th, table td{
        border-right: 1px solid #dddee1;
        padding: 5px;
    }
    .log{
        padding: 5px 0;
    }
    .log-company{
        display: inline-block;
        width: 60px;
        text-align: right;
    }
    .log-count{
        display: inline-block;
        width: 50px;
    }
    .select-bank-container{
        padding: 10px;
        margin-bottom: 10px;
    }
    .fill-info-btn{
        color: #2d8cf6;
        text-decoration: underline;
        cursor: pointer;
    }
    .bank-card{
        display: block;
        margin: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .bank-card:hover{
        background: #e5e5e5;
    }
</style>
<template>
  <div>
    <Tabs
      v-model="active_tab"
      type="card"
      :animated="false"
    >
      <TabPane
        name="company_export"
        label="付款充值预支导出"
      >
        <h2 class="text-center">
          付款充值预支导出
        </h2>
        <ExpenseGroupExport
          ref="companyExport"
          type="company"
          :banks="banks"
          :banks_hash="banks_hash"
        />
      </TabPane>
      <TabPane
        name="outsource_bank_export"
        label="兼职外包付款导出-银行卡"
      >
        <h2 class="text-center">
          兼职外包付款导出-银行卡
        </h2>
        <ExpenseGroupExport
          ref="outsourceBankExport"
          type="outsource-bank"
          :banks="banks"
          :banks_hash="banks_hash"
        />
      </TabPane>
      <TabPane
        name="outsource_alipay_export"
        label="兼职外包付款导出-支付宝"
      >
        <h2 class="text-center">
          兼职外包付款导出-支付宝
        </h2>
        <ExpenseGroupExport
          ref="outsourceAlipayExport"
          type="outsource-alipay"
          :banks="banks"
          :banks_hash="banks_hash"
        />
      </TabPane>
      <TabPane
        name="customer_export"
        label="报销导出"
      >
        <h2 class="text-center">
          报销导出
        </h2>
        <ExpenseGroupExport
          ref="customerExport"
          type="customer"
          :banks="banks"
          :banks_hash="banks_hash"
        />
      </TabPane>
      <TabPane
        name="log"
        label="导出历史"
      >
        <ExpenseGroupExportLog @reload="reloadLog" />
      </TabPane>
    </Tabs>
  </div>
</template>
<script route="/fin/expense_group_export_to_pay">
  import UserFlowBase from '../components/flow/user_flow_base';
  import ExpenseGroupExport from './components/expense_group_export_to_pay';
  import ExpenseGroupExportLog from './components/expense_group_export_log';
  export default {
    /* router_info_start */
    router_info: '/fin/expense_group_export_to_pay',
    /* router_info_end */

    components: { UserFlowBase, ExpenseGroupExport, ExpenseGroupExportLog },
    data() {
      return {
        reload_expense_group_export_path: Util.api.reload_expense_group_export,
        active_tab: 'company_export',
        banks: [],
        banks_hash: {}
      }
    },
    computed: {
      //
    },
    created() {
      this.getBanks();
    },
    mounted() {
      //
    },
    methods: {
      getBanks() {
        Util.ajax.get(Util.api.get_expense_payment_banks, {
          //
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.banks = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((c) => {
              this.banks.push(c);
              this.banks_hash[c.id] = c;
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      reloadLog(expense_group_ids) {
        this.reloading = true;
        Util.ajax.get(this.reload_expense_group_export_path, {
          params: {
            expense_group_ids: expense_group_ids
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.reloading = false;
          if (res.code === 1) {
            const data = res.data;
            this.reloadExpenseGroupExport(data);
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.reloading = false;
          console.log(e);
          this.$Modal.error({
            title: '错误',
            content: e.message
          });
        });
      },
      reloadExpenseGroupExport(expense_groups) {
        const expense_group = expense_groups[0];
        const payment_type = expense_group.payment_type;
        if ([1, 3, 4].indexOf(payment_type) > -1) {
          //付款,充值
          this.active_tab = 'company_export';
          this.$refs.companyExport.reloadExpenseGroupExport(expense_groups);
        } else if ([0, 2].indexOf(payment_type) > -1) {
          //报销,预支
          this.active_tab = 'customer_export';
          this.$refs.customerExport.reloadExpenseGroupExport(expense_groups);
        }
      },
      reloadExpenseGroupExportFail(e) {
        console.log(e);
        this.$Modal.error({title: '提示', content: '加载数据失败, 请重试!'});
      }
    }
  }
</script>
